import { useState } from 'react';
import { CreatePassword } from './CreatePassword';
import { RedefinePasswordSuccess } from './RedefinePasswordSuccess';
import { axiosInstance } from '../../../utils/axiosInstance';
import { AxiosRequestConfig } from 'axios';
import { showToast } from '../../../components/atoms/Toast/Toast';

export const RedefinePassword = () => {
  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = async (password) => {
    setIsLoading(true);
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const query = new URLSearchParams(window.location.search);

    const requestOptions: AxiosRequestConfig = {
      headers,
      url: `${process.env.NEXT_PUBLIC_API_PRO}/login/update_password`,
      method: 'POST',
      data: {
        password,
        token: query.get('reset_password_token'),
      },
    };

    try {
      await axiosInstance(requestOptions);
      setIsLoading(false);

      setStep(1);
    } catch (error) {
      setIsLoading(false);
      showToast({
        type: 'error',
        message: 'Erro inesperado. Tente novamente.',
      });
    }
  };

  return (
    <>
      {step === 0 && (
        <CreatePassword
          onButtonClick={handleButtonClick}
          isButtonLoading={isLoading}
        />
      )}
      {step === 1 && <RedefinePasswordSuccess />}
    </>
  );
};
